import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_MUTATION } from '../graphql/mutations'
import { transformToSaveLocationTypesAndLocationTypeCategoriesArgs } from '../graphql/transformers'
import { SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES } from '../redux/action-types'

const useSaveLocationTypesAndLocationTypeCategoriesMutation =
  refetchLastEvent => {
    const dispatch = useDispatch()

    const { isLoading, error } = useSelector(
      store => store.locationTypes.locationTypesAndLocationTypeCategories,
    )

    const mutate = useCallback(
      async data => {
        await apolloService.mutate(
          SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_MUTATION,
          {
            data: transformToSaveLocationTypesAndLocationTypeCategoriesArgs(
              data,
            ),
          },
          dispatch,
          SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES,
        )

        refetchLastEvent()
      },
      [dispatch, refetchLastEvent],
    )

    return [mutate, { isLoading, error }]
  }

export default useSaveLocationTypesAndLocationTypeCategoriesMutation
